module.exports = __webpack_public_path__ + "img/RE.d84747e0.svg";